import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const TW2418Icon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "TW2418IconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="18"
      viewBox="0 0 24 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <g clipPath="url(#clip0_1813_680)">
        <rect width="24" height="18" fill="white" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 0V18H24V0H0Z"
          fill="#EF0000"
        />
        <mask
          id="mask0_1813_680"
          mask-type="luminance"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="24"
          height="18"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 0V18H24V0H0Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask0_1813_680)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 0V10.5H13.5V0H0Z"
            fill="#2E42A5"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6.54761 8.10801L5.43637 9.49439L5.16719 7.73813L3.51164 8.38315L4.15666 6.72759L2.40039 6.45842L3.78677 5.34717L2.40039 4.23593L4.15666 3.96675L3.51164 2.3112L5.16719 2.95622L5.43637 1.19995L6.54761 2.58633L7.65886 1.19995L7.92803 2.95622L9.58359 2.3112L8.93857 3.96675L10.6948 4.23593L9.30845 5.34717L10.6948 6.45842L8.93857 6.72759L9.58359 8.38315L7.92803 7.73813L7.65886 9.49439L6.54761 8.10801ZM6.54734 7.4939C7.73296 7.4939 8.6941 6.53276 8.6941 5.34714C8.6941 4.16152 7.73296 3.20038 6.54734 3.20038C5.36171 3.20038 4.40058 4.16152 4.40058 5.34714C4.40058 6.53276 5.36171 7.4939 6.54734 7.4939ZM8.26459 5.34723C8.26459 6.29573 7.49568 7.06464 6.54718 7.06464C5.59869 7.06464 4.82978 6.29573 4.82978 5.34723C4.82978 4.39873 5.59869 3.62982 6.54718 3.62982C7.49568 3.62982 8.26459 4.39873 8.26459 5.34723Z"
            fill="#FEFFFF"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_1813_680">
          <rect width="24" height="18" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default TW2418Icon;
